import { combineSlices } from "@reduxjs/toolkit";

import { currentDocumentSlice } from "./currentDocument/currentDocumentSlice";
import { documentsSlice } from "./documents/documentsSlice";
import scoringSlice from "./scoring/scoringSlice";

export default combineSlices(documentsSlice, currentDocumentSlice, {
  scoring: scoringSlice,
});
